import Button from 'components/Button/Button'
import { Input } from 'components/Input'
import { ModalTemplate } from 'components/ModalTemplate'
import { Text } from 'components/Text'
import styled from 'styled-components'

export const SignInModalContainer = styled(ModalTemplate)``

export const SignInModalContent = styled.div`
  width: 100%;
`

export const SignInModalHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const SignInLoadingContainer = styled.div`
  display: 'flex';
  height: 340px;
  justify-content: 'center';
  align-items: 'center';
`

export const SignInModalHeaderLogo = styled.img`
  max-width: 8.35rem;
  z-index: 2;
  margin-bottom: 20px;
`

export const SignInModalForm = styled.div``

export const SignInModalInput = styled(Input)`
  margin: 12px 0px;
`

export const SignInModalInputError = styled(Text).attrs({
  preset: 'small',
})`
  color: ${({ theme }) => theme.colors.error};
  margin-bottom: 5px;
`

export const SignInModalButton = styled(Button)`
  width: 47%;
`

export const SignInModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`

export const ResetPasswordText = styled.div`
  justify-content: center;
  display: flex;
  font-size: small;
  margin-top: 20px;
`
export const ResetPasswordLink = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  margin-left: 5px;
`
